import URI from 'urijs'

class uriHandler {
    /**
     * add param if not in url, update it
     * if it already exists
     * @param object
     */
    static addQueryParams(paramObj) {
        const instance = new URI(window.location.search)

        for (let key in paramObj) {
            // if the key is already there dont add it again
            // if it's a different value update it
            if (instance.hasQuery(key)) {
                instance.setQuery({ [key]: paramObj[key] })
            } else {
                //else append the param with its value
                instance.addQuery({ [key]: paramObj[key] })
            }
            0
        }

        return instance
    }

    /**
     * Takes an array of params to remove
     * if no params passed, just return pathname
     * @param  {Array}  params
     * @return {String} the new path
     */
    static removeQueryParams(params = [], search) {
        if (params.length < 1) return window.location.pathname

        const searchCheck = search || window.location.search
        const instance = new URI(searchCheck)

        //loops through the params that will be removed
        params.forEach(param => {
            if (instance.hasQuery(param)) {
                instance.removeQuery(param)
            }
        })

        return instance
    }

    static hasQueryParam(name, search) {
        const searchCheck = search || window.location.search
        const instance = new URI(searchCheck)

        return instance.hasQuery(name)
    }

    static getParamValue(name, search) {
        const searchCheck = search || window.location.search
        const instance = new URI(searchCheck)
        if (instance.hasQuery(name)) {
            return instance.query(true)[name]
        }
        return false
    }

    static updateURL(path, refresh = false) {
        if (refresh) {
            window.history.replaceState({}, null, path)
        } else {
            window.history.pushState({}, null, path)
        }
    }

    static hasDoubleSlashes() {
        const pathname = window.location.pathname

        return pathname.indexOf('//') === 0
    }

    static fixProtocol(url) {
        if ([undefined, ''].includes(url)) {
            return url
        } else {
            const oldurl = new URI(url)
            return oldurl.protocol(window.location.protocol).toString()
        }
    }

    static isInSameSubDomain(url1, url2) {
        return URI(url1).subdomain() == URI(url2).subdomain() && (URI(url1).domain() && URI(url2).domain())
    }

    static appendCorsQueryParam(url) {
        return URI(url)
            .addQuery('app', 'react')
            .toString()
    }
}

export default uriHandler
